export default __webpack_public_path__ + "static/media/travel-agency-circle.1dd05b28.webp";